import * as filtersConstants from '../constants/filters';
import { BUILD_URL } from '../constants/mobile';

export const applyFiltersAction = () => ({
  type: filtersConstants.APPLY_FILTERS,
});

export const cancelFiltersAction = () => ({
  type: filtersConstants.CANCEL_FILTERS,
});

export const saveFiltersForCancelAction = (payload) => ({
  type: filtersConstants.SAVE_FILTERS_FOR_CANCEL,
  payload,
});

export const buildUrlAction = () => ({
  type: BUILD_URL,
});
